import React from 'react';
import { observer } from 'mobx-react';
import { Field } from 'libs/forms/views/field';
// import {Validation} from 'libs/forms/views/validation';
import { CheckboxWrapper, Checkbox, CheckboxText } from 'libs/forms/styles';

import { BoolFieldStore, ReferenceFieldStore } from 'libs/forms/fieldStores';

@observer
export class CheckboxField extends Field {
  static defaultStore = BoolFieldStore;

  componentDidMount() {
    const { fieldStore } = this.props;
    if (fieldStore instanceof ReferenceFieldStore && !fieldStore.value?.value) {
      const option = fieldStore.optionsManager.selectables.find(
        opt => opt[fieldStore.conf.valueKey] === false,
      );
      if (option) {
        fieldStore.Select(option);
      }
    }
  }

  updateValue = e => {
    const { fieldStore } = this.props;
    if (fieldStore instanceof ReferenceFieldStore) {
      let checked = false;
      if (e.target.checked) {
        checked = true;
      }
      fieldStore.UpdateValue(
        fieldStore.optionsManager.options.find(
          opt => opt[fieldStore.conf.valueKey] === checked,
        ),
      );
    } else {
      fieldStore.UpdateValue(e.target.checked);
    }
  };

  render() {
    const { fieldStore, editComponent, responsive } = this.props;
    const Tag = editComponent || CheckboxWrapper;
    let checked;
    if (this.props.fieldStore instanceof ReferenceFieldStore) {
      checked = fieldStore.value?.[fieldStore.conf.valueKey] || false;
    } else {
      checked = !!fieldStore.value || false;
    }
    const description = checked
      ? fieldStore.conf.descriptionChecked
      : fieldStore.conf.descriptionUnChecked;

    return (
      <Tag focussed={fieldStore.isFocussed} responsive={responsive}>
        <CheckboxText dangerouslySetInnerHTML={{ __html: description }} />
        <Checkbox
          autoFocus={fieldStore.autoFocus}
          id={this.inputId}
          type='checkbox'
          checked={checked}
          value={fieldStore.fieldName}
          onBlur={this.onBlur}
          onChange={this.updateValue}
          posting={
            fieldStore.formStore.posting
              ? fieldStore.formStore.posting
              : undefined
          }
        />
      </Tag>
    );
  }
}
